export var ktsKey = [
    'Button_select',
    'au.COMPONENTS.modal.button.decide',
    'au.COMPONENTS.modal.button.save',
    'au.COMPONENT.KtsMultiSelectComponent.label.belongs',
    'au.COMPONENT.KtsMultiSelectComponent.label.department',
    'au.COMPONENT.KtsMultiSelectComponent.label.name',
    'au.COMPONENT.KtsMultiSelectComponent.select.belongs',
    'au.COMPONENT.KtsMultiSelectComponent.select.dispDepartment',
    'au.COMPONENT.KtsMultiSelectComponent.select.section',
    'au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.label.partner_company_name',
    'au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.constructionClassification',
    'au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.constructionMiddleClassification',
    'au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.area',
    'au.COMPONENTS.label.task_name',
    'au.COMPONENTS.label.task_other_field',
    'au.COMPONENTS.label.task_plan_date',
    'au.COMPONENTS.label.task_act_date',
    'au.COMPONENTS.label.task_plan_datetime',
    'au.COMPONENTS.label.task_act_datetime',
    'au.COMPONENTS.label.task_file_genre',
    'au.COMPONENTS.label.task_referrer_type',
    'au.COMPONENTS.label.task_file_title',
    'au.COMPONENTS.label.task_file',
    'au.COMPONENTS.label.task_partner_company',
    'au.COMPONENTS.label.task_is_ok',
    'au.COMPONENTS.label.task_material',
    'au.COMPONENTS.label.task_material_label',
    'au.COMPONENTS.label.task_necessity',
    'au.COMPONENTS.label.task_note_file',
    'au.COMPONENTS.label.task_note_visit',
    'au.COMPONENTS.label.task_note_confirm',
    'au.COMPONENTS.label.task_note_material',
    'au.COMPONENTS.label.task_note_standard',
    'au.COMPONENTS.label.task_note',
    'au.COMPONENT.KtsTaskComponent.label.file',
    'au.COMPONENT.KtsTaskComponent.label.date',
    'au.COMPONENT.KtsTaskComponent.label.datetime',
    'au.COMPONENT.KtsTaskComponent.label.select',
    'au.COMPONENT.KtsTaskComponent.label.select_is_ok',
    'au.COMPONENT.KtsTaskComponent.label.select_necessity',
    'au.COMPONENT.KtsTaskComponent.label.text',
    'au.COMPONENT.KtsTaskComponent.Modal.save.confirm',
    'au.COMPONENT.KtsTaskComponent.Modal.save.confirmIncludingDelete',
    'au.COMPONENTS.label.task_completion',
    'au.COMPONENTS.label.task_incomplete',
    'au.COMPONENTS.label.task_datetime',
    'au.COMPONENTS.label.task_date',
    'au.COMPONENTS.label.task_report_status',
    'au.COMPONENTS.select.task_ok',
    'au.COMPONENTS.select.task_ng',
    'au.COMPONENTS.select.task_necessary',
    'au.COMPONENTS.select.task_unnecessary',
    'au.COMPONENT.KtsConstructionTaskComponent.Modal.save.confirm',
    'au.COMPONENT.KtsConstructionTaskComponent.Modal.save.confirmIncludingDelete',
    'au.COMPONENTS.button.task_display',
    'au.COMPONENT.KtsGeneralTaskComponent.label.noTask',
    'au.COMPONENT.KtsGeneralTaskComponent.label.taskNameNotEntered',
    'au.COMPONENT.KtsGeneralTaskComponent.label.classificationUnselected',
    'au.COMPONENT.KtsGeneralTaskComponent.label.middleClassificationUnselected',
    'au.COMPONENT.KtsGeneralTaskComponent.label.remarks',
    'au.COMPONENT.KtsGeneralTaskComponent.Modal.save.confirm',
    'au.COMPONENT.KtsGeneralTaskComponent.Modal.save.confirmIncludingDelete',
    'au.COMPONENT.KtsImportTargetComponent.select.all',
    'au.COMPONENT.KtsImportTargetComponent.label.target',
    'au.COMPONENT.KtsImportTargetComponent.label.supervisor',
    'au.COMPONENT.KtsImportTargetComponent.label.step',
    'au.COMPONENT.KtsImportTargetComponent.label.task',
    'au.COMPONENTS.label.progress_construction',
    'au.COMPONENTS.label.progress_task',
    'au.COMPONENTS.label.progress_delay',
    'au.COMPONENTS.label.progress_count',
    'au.COMPONENT.KtsReportComponent.select.all',
    'au.COMPONENT.KtsReportComponent.button.execution',
    'au.COMPONENT.KtsReportComponent.button.start',
    'au.COMPONENT.KtsReportComponent.button.end',
    'au.COMPONENT.KtsReportComponent.button.select',
    'au.COMPONENT.KtsReportComponent.button.save',
    'au.COMPONENT.KtsReportComponent.button.photography',
    'au.COMPONENT.KtsReportComponent.button.upload',
    'au.COMPONENT.KtsReportComponent.end_processing.success',
    'au.COMPONENT.KtsReportComponent.start_processing.confirm',
    'au.COMPONENT.KtsReportComponent.label.work_selection',
    'au.COMPONENT.KtsReportComponent.label.please_select',
    'au.COMPONENT.KtsReportComponent.label.type_scheduled',
    'au.COMPONENT.KtsReportComponent.label.actual_date',
    'au.COMPONENT.KtsReportComponent.label.result_report',
    'au.COMPONENT.KtsReportComponent.label.progress',
    'au.COMPONENT.KtsReportComponent.label.content',
    'au.COMPONENT.KtsReportComponent.title.end_processing',
    'au.COMPONENT.KtsReportComponent.title.photo_selection',
    'au.COMPONENT.KtsReportComponent.label.photo',
    'au.COMPONENT.KtsReportComponent.label.not_registered',
    'au.COMPONENT.KtsReportComponent.label.caption',
    'au.COMPONENT.KtsReportComponent.label.add_photo',
    'au.COMPONENT.KtsReportComponent.label.description.before_arrival',
    'au.COMPONENT.KtsReportComponent.label.description.arrival',
    'au.COMPONENT.KtsReportComponent.label.description.visiting',
    'au.COMPONENT.KtsReportComponent.label.claim',
    'au.COMPONENT.KtsReportComponent.label.incident',
    'au.COMPONENT.KtsReportComponent.button.content',
    'au.COMPONENT.KtsReportComponent.title.content',
    'au.COMPONENT.KtsReportComponent.label.content.message',
    'au.COMPONENT.KtsReportComponent.label.content.caution',
    'au.COMPONENT.KtsReportComponent.content.success',
    'au.COMPONENT.KtsTaskConditionComponent.label.plan_date',
    'au.COMPONENT.KtsTaskConditionComponent.label.status',
    'au.COMPONENT.KtsTaskConditionComponent.select.notCompleted',
    'au.COMPONENT.KtsTaskConditionComponent.select.completion',
    'au.COMPONENTS.label.task_outline_name',
    'au.COMPONENTS.label.task_outline_field',
    'au.COMPONENT.KtsOutlineComponent.Modal.save.confirm',
    'au.COMPONENT.KtsOutlineComponent.Modal.save.confirmIncludingDelete',
    'au.COMPONENT.KtsConstructionOutlineComponent.Modal.save.confirm',
    'au.COMPONENT.KtsSupervisorAddRowComponent.input.default_name',
    'au.COMPONENT.KtsSupervisorComponent.label.construction_supervisor',
    'au.COMPONENTS.label.task_order_date',
    'au.COMPONENTS.label.task_delivery_date',
    'au.COMPONENTS.label.task_delivery_destination',
    'au.COMPONENTS.label.task_desire_date',
    'au.COMPONENTS.label.task_delivery_name',
    'au.COMPONENTS.label.task_delivery_company',
    'au.COMPONENTS.label.task_delivery_charge',
    'au.COMPONENTS.label.task_delivery_arrival_note',
    'au.COMPONENTS.label.task_delivery_supplier',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.id',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.type',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.special',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.code',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.name',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.manufacturers',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.models',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.elements',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.quantity',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.unit',
    'au.COMPONENT.KtsConstructionMaterialComponent.label.noTask',
    'au.COMPONENT.KtsConstructionMaterialComponent.Modal.save.confirm',
    'au.COMPONENT.KtsConstructionMaterialComponent.Modal.required.quantity',
    'au.COMPONENT.KtsConstructionMaterialComponent.select_material_modal.label.title',
    'au.COMPONENT.KtsConstructionMaterialComponent.select_material_modal.label.code.unselected',
    'au.COMPONENT.KtsConstructionMaterialComponent.select_material_modal.label.manufacturer.unselected',
    'au.COMPONENT.KtsGanttComponent.label.plan',
    'au.COMPONENT.KtsGanttComponent.label.act',
    'au.COMPONENT.KtsGanttComponent.label.planDelay',
    'au.COMPONENT.KtsGanttComponent.label.completeDelay',
    'au.COMPONENT.KtsGanttComponent.label.noDate',
    'au.COMPONENT.KtsGanttComponent.option.yearMonthFormat',
    'au.COMPONENT.KtsGanttComponent.label.openAll',
    'au.COMPONENT.KtsGanttComponent.label.closeAll',
    'au.COMPONENT.KtsGanttComponent.label.closeAll',
    'au.COMPONENT.KtsGeneralGanttComponent.label.noStoreName',
    'au.COMPONENT.KtsReportDownloadComponent.select.all',
    'au.COMPONENT.KtsReportDownloadComponent.label.construction_class_selection',
    'au.COMPONENT.KtsReportDownloadComponent.label.task_selection',
    'au.COMPONENT.KtsReportDownloadComponent.label.select_count',
    'au.COMPONENT.KtsReportDownloadComponent.label.select_count.unit',
    'au.COMPONENT.KtsReportDownloadComponent.label.list',
    'au.COMPONENT.KtsReportDownloadComponent.label.no',
    'au.COMPONENT.KtsReportDownloadComponent.label.file',
    'au.COMPONENT.KtsReportDownloadComponent.label.task_info',
    'au.COMPONENT.KtsReportDownloadComponent.label.term',
    'au.COMPONENT.KtsReportDownloadComponent.label.image_info',
    'au.COMPONENT.KtsReportDownloadComponent.label.construction_class',
    'au.COMPONENT.KtsReportDownloadComponent.label.task_name',
    'au.COMPONENT.KtsReportDownloadComponent.label.cdate',
    'au.COMPONENT.KtsReportDownloadComponent.label.shooting_date',
    'au.COMPONENT.KtsReportDownloadComponent.label.genre',
    'au.COMPONENT.KtsReportDownloadComponent.label.file_name',
    'au.COMPONENTS.label.progress_button_summary',
    'au.COMPONENT.KtsConstructionClassificationComponent.select.classification',
    'au.COMPONENT.KtsConstructionClassificationComponent.select.middle_classification',
    'au.COMPONENTS.label.environment_attention_login',
    'au.COMPONENTS.label.environment_attention_content',
    'au.COMPONENT.KtsReceptionContentComponent.label.noContent',
    'au.COMPONENT.KtsReceptionContentComponent.label.openAll',
    'au.COMPONENT.KtsReceptionContentComponent.label.closeAll',
    'au.COMPONENT.KtsDepartmentComponent.select.department',
    'au.COMPONENT.KtsDepartmentComponent.select.section',
    'au.COMPONENT.KtsMapComponent.error.auth',
    'au.COMPONENT.KtsMapComponent.error.searchAddr',
    'au.COMPONENT.KtsFileDownloadComponent.button.download',
    'au.COMPONENT.KtsConstructionTaskVisitComponent.error.statusRequired',
    'au.COMPONENT.KtsDateTimeComponent.option.format',
    'au.COMPONENT.KtsDateTimeComponent.option.formatDate',
    'au.COMPONENT.KtsDateTimeComponent.option.formatTime',
    'au.COMPONENT.KtsDateTimeComponent.option.dayOfWeekStart',
    'au.COMPONENT.KtsDateTimeComponent.label.january',
    'au.COMPONENT.KtsDateTimeComponent.label.february',
    'au.COMPONENT.KtsDateTimeComponent.label.march',
    'au.COMPONENT.KtsDateTimeComponent.label.april',
    'au.COMPONENT.KtsDateTimeComponent.label.may',
    'au.COMPONENT.KtsDateTimeComponent.label.june',
    'au.COMPONENT.KtsDateTimeComponent.label.july',
    'au.COMPONENT.KtsDateTimeComponent.label.august',
    'au.COMPONENT.KtsDateTimeComponent.label.september',
    'au.COMPONENT.KtsDateTimeComponent.label.october',
    'au.COMPONENT.KtsDateTimeComponent.label.november',
    'au.COMPONENT.KtsDateTimeComponent.label.december',
    'au.COMPONENT.KtsDateTimeComponent.label.sunday',
    'au.COMPONENT.KtsDateTimeComponent.label.monday',
    'au.COMPONENT.KtsDateTimeComponent.label.tuesday',
    'au.COMPONENT.KtsDateTimeComponent.label.wednesday',
    'au.COMPONENT.KtsDateTimeComponent.label.thursday',
    'au.COMPONENT.KtsDateTimeComponent.label.friday',
    'au.COMPONENT.KtsDateTimeComponent.label.saturday',
];
//# sourceMappingURL=message.service.js.map